/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

/**
 * Firma ismini title case formatına dönüştürür
 * "MUHAMMET FİRMA" -> "Muhammet Firma"
 * Türkçe karakterleri destekler
 * 
 * @param {string} name - Formatlanacak firma ismi
 * @returns {string} - Formatlanmış firma ismi
 */
export const formatFirmaName = (name) => {
  if (!name || typeof name !== 'string') {
    return name || '';
  }

  // Boşlukları normalize et ve trim yap
  const trimmed = name.trim();
  if (!trimmed) {
    return '';
  }

  // Kelimeleri ayır
  const words = trimmed.split(/\s+/);
  
  // Her kelimeyi formatla
  const formattedWords = words.map(word => {
    if (!word) return '';
    
    // İlk harfi büyük, geri kalanını küçük yap
    // Türkçe karakterleri koruyarak
    const firstChar = word.charAt(0).toLocaleUpperCase('tr-TR');
    const restChars = word.slice(1).toLocaleLowerCase('tr-TR');
    
    return firstChar + restChars;
  });

  return formattedWords.join(' ');
};

export default formatFirmaName;

